<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/grinding.png')"
      >
      </parallax>
      <div class="container">
        <h3 class="title mt-5">{{ $t('blog.pageTitle') }}</h3>
      </div>
    </div>
    <div class="section">
      <div class="container text-left">
        <!-- <div class="row pt-5">
          <div class="col-lg-4 text-left">
            <img
              src="img/image_blog/TEF-05595.jpg"
              class="rounded animated fadeInDown"
              height="25%"
              width="100%"
            />
            <div class="row">
              <div class="col-6">  
              </div>
              <div class="col-6">  
                <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-dark" style="background-color: #DCDCDC;">
                 April 25, 2025
                </n-button>
              </div>
            </div>
            <h5 class="font-weight-bold align-middle mt-4">
              New Workshop: Voyager Gresik is Now Officially Operating!
            </h5>
            <h5>
              Following the establishment of our two main facilities—“Discovery” in Cikarang and “Endeavor” in Cilegon—the launch of “Voyager” in Gresik further strengthens our service reach across Java, from west to east. ...
            </h5>
            <br>

            <a target="_BLANK" href="https://www.linkedin.com/posts/pt-tef_voyagergresik-tefindonesia-industrialsolutions-activity-7320484443893202944-XVmE?utm_source=share&utm_medium=member_desktop&rcm=ACoAADSmxPEBFNXg4a7tobPxZzIWN-VsGYc2i1w">
              <n-button type="default" size="sm" class="btn btn-success btn-round btn-lg  align-self-center" style="padding: 10px;">
                  <span>{{ $t('blog.readMore') }}</span>
              </n-button>
            </a>
          </div>
          <div class="col-lg-4 text-left">
            <img
              src="img/image_blog/blog1.png"
              class="rounded animated fadeInDown"
              height="25%"
              width="100%"
            />
            <div class="row">
              <div class="col-6">  
              </div>
              <div class="col-6">  
                <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-dark" style="background-color: #DCDCDC;">
                 March 18, 2025
                </n-button>
              </div>
            </div>
            <h5 class="font-weight-bold align-middle mt-4">
              🌍 Corrosion: The Silent Destroyer of Metal Structures 🔧⚡
            </h5>
            <h5>
              Did you know corrosion costs the global economy $2.5 trillion <br>
              annually—about 3-4% of global GDP? From pipeline failures to <br> 
              structural collapses, corrosion is a major challenge across industries <br>
              like oil & gas, infrastructure, manufacturing, and utilities. ...
            </h5>
           <br>

            <a target="_BLANK" href="https://www.linkedin.com/posts/pt-tef_types-of-corrosion-and-how-to-prevent-them-activity-7305766448767868928-zk0B?utm_source=share&utm_medium=member_desktop&rcm=ACoAADSmxPEBFNXg4a7tobPxZzIWN-VsGYc2i1w">
              <n-button type="default" size="sm" class="btn btn-success btn-round btn-lg  align-self-center" style="padding: 10px;">
                  <span>{{ $t('blog.readMore') }}</span>
              </n-button>
            </a>
          </div>
          <div class="col-lg-4 text-left">
            <img
              src="img/bussines_mix.jpg"
              class="rounded animated fadeInDown"
              height="25%"
              width="100%"
            />
            <div class="row">
              <div class="col-6">  
              </div>
              <div class="col-6">  
                <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-dark" style="background-color: #DCDCDC;">
                 November 7, 2024
                </n-button>
              </div>
            </div>
            <h5 class="font-weight-bold align-middle mt-4">
              PT. Tokki Engineering and Fabrication we’re dedicated to delivering customized solutions that keep industries running smoothly. 🛠️💼
            </h5>
            <h5>
              Explore how TEF combines expertise in service and fabrication to meet the unique needs of our clients. Let’s connect and discuss how we can bring value to your operations! hashtag
            </h5>
            <br>
            <a target="_BLANK" href="https://www.linkedin.com/pulse/tef-business-mix-pt-tef-wvxdc/?trackingId=mkBsa5uv6qaRxydZeiJDpA%3D%3D">
              <n-button type="default" size="sm" class="btn btn-success btn-round btn-lg  align-self-center" style="padding: 10px;">
                  <span>{{ $t('blog.readMore') }}</span>
              </n-button>
            </a>
          </div>
        </div> -->

        <!--  <img
            src="img/empty.png"
            class="rounded animated fadeInDown"
          />
          <p><strong> Content is empty </strong></p> -->

        <div class="row" v-if="table.data.length">
          <div class="col-lg-4 col-md-6 mb-5 d-flex" v-for="(row, i) in table.data" :key="i">
            <router-link :to="/detail-blog/+row.code" class="blog-card animated fadeInDown w-100">
              <div class="blog-card-image">
                <img :src="storageUrl+'banner_content/'+row.banner" :alt="row.title" />
                <span class="blog-card-date">{{ moment(row.created_at).locale($i18n.locale).format('LL') }}</span>
              </div>
              <div class="blog-card-body">
                <h5 class="blog-card-title">{{ row.title }}</h5>
                <p class="blog-card-excerpt">{{ truncate(row.description, 130) }}</p>
                <div class="blog-card-footer">
                  <span class="blog-card-author">{{ $t('blog.byAdmin') }}</span>
                  <span class="blog-card-readmore">
                    {{ $t('blog.readMore') }} <i class="fa fa-arrow-right ml-1"></i>
                  </span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="text-center py-5" v-else>
          <img src="img/empty.png" alt="No blog posts available" class="mb-3" style="max-width: 180px; opacity: 0.6;" />
          <h5 class="text-muted">{{ $t('blog.empty') }}</h5>
        </div>

      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';
import { Card, Button, FormGroupInput } from '@/components';
import config from '@/configs/config';
import Api from '@/helpers/api';
var moment = require('moment');
import blog from '@/services/blog.service';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Carousel.name]: Carousel,
    [Button.name]: Button,
    [CarouselItem.name]: CarouselItem
  },
  data () {
    return {
      moment:moment,
      form: {
        add: true,
        title: "",
        show: false
      },
      table: {
        data: []
      },
      search: {
        position: '',
        level: '',
        location: '',
        requirements: '',
        status: '',
      },

      storageUrl : config.blogStorageUrl,

    }
  },
  mounted(){
    this.getBlog();
  },
  methods: {
    getBlog(param){
      let context = this;
      Api(context, blog.index()).onSuccess(function(response) {
          context.table.data = response.data.data.data;
      }).onError(function(error) {
          context.table.data = [];
      })
      .call()
    },
    truncate(str, max) {
      if (!str) return "";
      // strip HTML tags from rich-text content before truncating to plain-text excerpt
      const plain = str.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      // handle multi-byte chars safely
      const s = Array.from(plain).slice(0, max).join("");
      return s.length < plain.length ? s + "…" : s;
    },
    toDetailProduct(param){
      this.$router.push('/detail-product/'+param)
    }
  }
};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .blog-card {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    text-decoration: none;
    color: inherit;
  }

  .blog-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: inherit;
  }

  .blog-card-image {
    position: relative;
    width: 100%;
    height: 210px;
    overflow: hidden;
    background: #f1f1f1;
  }

  .blog-card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
  }

  .blog-card:hover .blog-card-image img {
    transform: scale(1.08);
  }

  .blog-card-date {
    position: absolute;
    bottom: 12px;
    left: 12px;
    background: rgba(0, 140, 69, 0.92);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 20px;
    letter-spacing: 0.3px;
  }

  .blog-card-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 22px 22px 18px;
  }

  .blog-card-title {
    font-weight: 700;
    color: #222;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 48px;
  }

  .blog-card-excerpt {
    color: #6c757d;
    font-size: 14px;
    line-height: 1.6;
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 16px;
  }

  .blog-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 14px;
    border-top: 1px solid #eee;
    font-size: 13px;
  }

  .blog-card-author {
    color: #999;
    font-style: italic;
  }

  .blog-card-readmore {
    color: #008c45;
    font-weight: 700;
    white-space: nowrap;
  }

.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
